import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Verifica se l'elemento .list-v2 esiste prima di eseguire il codice
if (document.querySelector('.list-v2')) {
    gsap.utils.toArray('.list-v2-item').forEach((item, index) => {
        const numero = item.querySelector('.list-v2-item__numero');
        const titolo = item.querySelector('.list-v2-item__title');
        const hr = item.querySelector('hr');

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: item,
                start: 'top bottom',
                end: 'center center',
                scrub: true,
                // markers: true, // Decommentare per debug
            }
        });

        tl.from(numero, {x: '-100px', opacity: 0})
          .from(titolo, {x: '+50px', opacity: 0}, '<+=0.2')
          .from(hr, {scaleX: 0, transformOrigin: 'left'}, '<+=0.2');
    });
}
